export const RECAP_ENSEIGNE = {
  titre: 'Point de vente',
  libelleBtnEnvoyerParEmail: 'Envoyer par email',
  titreRecomDematerialisee: 'Recommandation dématérialisée',
  libelleBtnOuvrir: 'Ouvrir le portail Client',
  libelleBtnCopierLien: 'Copier le lien client',
  textRecomDematerialisee: 'Partagez votre recommandation dématérialisée avec le lien ci-dessus.',
  titreDocTelecharger: 'Documents à télécharger',
  libelleBtnRecommandation: 'Recommandation PDF',
  libelleBtnRecpBudgetairePDF: 'Récap budgétaire PDF',
  libelleBtnRecpBudgetaireExcel: 'Récap budgétaire Excel',
  titrePiecesJointes: 'Pièces jointes',
  societe: 'Société',
  assistant: 'Chargé de budget',
};

export const RECAP_RECOM = {
  titreRecap: 'Récapitulatif de la recommandation',
  libelleBtnValiderRecom: 'Valider la recommandation',
  btnModifier: 'Modifier la recommandation',
  recapPanneau: {
    titreRecomAffichage: 'RECOMMANDATION AFFICHAGE {type} N°{numero}',
    titreAdresse: 'Adresse :',
    titreCommentaire: 'Commentaire :',
    carcteristique: {
      titre: 'Caractéristiques :',
      reference: 'Référence :',
      regie: 'Regie :',
      categorie: 'Catégorie :',
      format: 'Format :',
      materiel: 'Matériel :',
      support: 'Support :',
      azimut: 'Azimut :',
    },
  },
  sansPanneaux: {
    title: 'Recommandation sans panneau',
    message: 'Il se peut que cette recommandation ait été créée dans la gestion commerciale d\'Affixe.\nElle ne peut pas s\'afficher correctement ici.',
  },
  libelleValiderDef: 'Valider définitivement',
  libelleBtnAppliquer: 'Appliquer',
  messageModal: 'Attention, vous allez transférer cette recommandation dans la gestion commerciale.  Elle ne pourra plus être modifiée / supprimée.',
  clientDevis: {
    libellePdv: '<b>{name}</b> n’existe pas dans la base de donnée gestion commerciale.',
    info: 'Veuillez rechercher ou créer le point de vente dans la base de donnée de la gestion commerciale.',
    btnSelect: 'Sélectionner',
    buttonCreate: 'Créer le point de vente'
  },
  messageErreur: 'Validation impossible de la recommandation. Le bloc annuel doit contenir une ou plusieurs années complètes.',
};

export const RECAP_BUDGETAIRE = {
  titreRecap: 'RECAPITULATIF BUDGETAIRE',
  tableau: {
    numero: 'N°',
    ancienPanneau: 'Sous contrat',
    reference: 'Référence',
    regie: 'Regie',
    format: 'Format',
    type: 'Type',
    categorie: 'Categorie',
    dateDebut: 'Date de début',
    dateFin: 'Date de fin',
    adresse: 'Adresse',
    prixBudgetBrutHT: 'Budget Brut HT',
    prixBudgetBrutNetHT: 'Budget Brut négocié  HT par {societe}',
    prixNet: 'Budget Net HT',
    tlpe: 'TLPE',
    honoraires: 'Honoraires HT',
    honoraireFraisTraitement: 'Frais de traitement HT',
    fraisTechnique: 'Frais techniques HT',
    total: 'Total HT',
    budgetProrata: 'BUDGET PRORATA',
    budgetAnnuel: 'BUDGET ANNUEL',
  },
  legendeSousContrat: 'Les lignes en jaune correspondent aux panneaux sous contrat.',
};

export const ENVOI_MAIL = {
  titreEnvoiMail: 'Envoyer la recommandation par email',
  destinataire: 'A',
  titleCC: 'Cc',
  titleCci: 'Cci',
  titleReplyTo: 'De',
  placeholderObjet: 'Ajouter un objet',
  placeholderMessage: 'Votre message',
  piecesJointes: 'Pièces jointes :',
  btnAjoutPJ: 'Ajouter une pièce jointe',
  btnAnnuler: 'Annuler',
  btnValider: 'Valider',
  masquerDansEmail: 'Masquer dans l\'email',
  supprimerDansEmail: 'Supprimer',
  afficherDansEmail: 'Afficher dans l\'email',
  messageErreur: 'Vous devez renseigner les champs obligatoires',
  messageErreurCciToIdentiques: 'impossible d\'envoyer le mail, les adresses email "Cci" et "A" doivent être différentes',
  messageConfirmation: 'Votre email a été envoyé',
};

export const RECAP_PAGE_DE_GARDE = {
  profil: 'Responsable de clientèle',
};
